export default [
    {
        path: '/pageViews',
        props: true,
        component: () => import('@/views/PageView'),
    },
];